import React, { useEffect, useState, useRef } from "react";
import "./FlightForm.css";
import { Accordion, Col, Row } from "react-bootstrap";
import flightIcon from "../../../../assets/images/packages/svg/flight.svg";
import {
  SingleCalendar,
  SpinnerLoading,
} from "../../../../components";
import { axiosGet, axiosPost, axiosPut } from "../../../../utils/apis/api";
import { TextField, Autocomplete } from "@mui/material";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import {ErrorPopUp} from "../../../../components";
import { useTranslation } from '../../../../contexts/TranslationContext';

const FlightForm = ({
  url,
  onReturn,
  onSuccess,
  package_name,
  selectedDates,
  package_component_id,
  selectedDestination,
  onRefresh,
  setItems
  
}) => {
  const [flightReservation, setFlightReservation] = useState({
    quotation_id: package_name,
    destination_airport: null,
    destination_airport_name: null,
    destination_airline: null,
    departure_date: null,
    return_date: null,
    num_of_passengers: 1,
    tickets: [""],
    contact_person_at_destination: null,
    already_reserved: true,
    quotation_item_date_from:  null, 
    quotation_item_date_to: null, 
    quotation_item_destination: selectedDestination.location,
    quotation_item_destination_row_id: selectedDestination.primary_destination_row_id,
  });
  const PAGE_LIMIT = 50;
  const [airports, setAirports] = useState([]);
  const [airlines, setAirlines] = useState([]);
  const [hasMoreAirports, setHasMoreAirports] = useState(true);
  const [hasMoreAirLines, setHasMoreAirLines] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState({});
  const [errorPopUp, setErrorPopUp] = useState(false);
  const destinationAirportRef = useRef(null);
  const destinationAirlineRef = useRef(null);
  const departureDateRef = useRef(null);
  const numOfPassengersRef = useRef(null);
  const contactDestRef = useRef(null);
  const ticketsRef = useRef(null);
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";
  const [reservationDetails, setReservationDetails] = useState();
  const [airlineInputValue, setAirlineInputValue] = useState('');
  const [airportInputValue, setAirportInputValue] = useState('');
  const formattedStart = selectedDates?.startDate
    ? dayjs(selectedDates.startDate).format("MMM D")
    : null;

  const formattedEnd = selectedDates?.endDate
    ? dayjs(selectedDates.endDate).format("MMM D")
    : null;
  const phoneRegex = /^\+?[0-9]{6,15}$/;
  const fetchAirports = async (
    newSearch = "",
    newStart = 0,
    append = false
  ) => {
    if (!hasMoreAirports && append) return; // Stop if no more items
    // setLoading(true);
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport`,
        {
          search: newSearch,
          start: newStart,
          limit: PAGE_LIMIT,
        }
      );
      const newItems = Array.isArray(response.result.items)
        ? response.result.items
        : []; // Ensure array
      setAirports((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMoreAirports(newItems.length === PAGE_LIMIT);
      // setStart(newStart + PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching items:", error);
      setAirports([]); // Ensure items is always an array
    } finally {
      // setLoading(false);
    }
  };

  const fetchAirlines = async (
    newSearch = "",
    newStart = 0,
    append = false
  ) => {
    if (!hasMoreAirLines && append) return; // Stop if no more items
    // setLoading(true);
    try {
      const response = await axiosGet(
        `${url}/api/method/alltimes.alltimes_travel.doctype.airline.airline.airline`,
        {
          search: newSearch,
          start: newStart,
          limit: PAGE_LIMIT,
        }
      );
      const newItems = Array.isArray(response.result.items)
        ? response.result.items
        : []; // Ensure array
      setAirlines((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMoreAirLines(newItems.length === PAGE_LIMIT);
      // setStart(newStart + PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching items:", error);
      setAirlines([]); // Ensure items is always an array
    } finally {
      // setLoading(false);
    }
  };

  const handleClickButton = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!flightReservation.destination_airport) {
      newErrors.destination_airport = t("DestinationAirportRequired");
    }
    if (!flightReservation.destination_airline) {
      newErrors.destination_airline = t("DestinationAirlineRequired");
    }
    if (!flightReservation.departure_date) {
      newErrors.departure_date = t("DepartureDateRequired");
    }

    if (!flightReservation.num_of_passengers || flightReservation.num_of_passengers == 0) {
      newErrors.num_of_passengers = t("NumberOfPassengersRequired");
    }


    const hasEmptyTickets =
      flightReservation.tickets &&
      flightReservation.tickets.some((ticket) => !ticket);

    if (
      !flightReservation.tickets ||
      flightReservation.tickets.length < flightReservation.num_of_passengers ||
      hasEmptyTickets
    ) {
      newErrors.tickets = t("TicketRequired");
    }

    if ( flightReservation.contact_person_at_destination && !phoneRegex.test(flightReservation.contact_person_at_destination)) {
      newErrors.contact_person = t("InvalidPhoneNumberFormat");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      if (errors.destination_airport && destinationAirportRef.current) {
        destinationAirportRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        destinationAirportRef.current.focus();
      }

      if (errors.destination_airline && destinationAirlineRef.current) {
        destinationAirlineRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        destinationAirlineRef.current.focus();
      }

      if (errors.departure_date && departureDateRef.current) {
        departureDateRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        departureDateRef.current.focus();
      } else if (errors.num_of_passengers && numOfPassengersRef.current) {
        numOfPassengersRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        numOfPassengersRef.current.focus();
      } else if (errors.tickets && ticketsRef.current) {
        ticketsRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        ticketsRef.current.focus();
      }
      else if (errors.contact_person && contactDestRef.current) {
        contactDestRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        contactDestRef.current.focus();
      }

      return;
    }
    setLoading(true);

    // No errors: proceed with submission
    setErrors({});

    const payload = {...flightReservation};
    // payload.tickets = JSON.stringify(flightReservation.tickets);
    payload.tickets = flightReservation.tickets;

    if (package_component_id) {
      payload["reservation_id"] = package_component_id;
      payload["row_id"] = reservationDetails.quotation_item_id;
    }
    
    if(flightReservation.return_date){
      const isUnValid = dayjs(flightReservation.departure_date).isSameOrAfter(flightReservation.return_date);
     
      if (isUnValid) {
        setErrorMessage(
          t("DepartureDateMustBeEarlierThanReturnDate")
        );
        setErrorPopUp(true);
        setLoading(false);
        return;
        
      } 
    }

    try {

      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      var response;
      if (package_component_id) {
        response = await axiosPut(
          `${url}/api/method/alltimes.www.api.update_flight_reservation`,
          payload,
          headers
        );
      } else {
        response = await axiosPost(
          `${url}/api/method/alltimes.www.api.add_flight_reservation`,
          payload,
          headers
        );
      }

      if (response.status === 200) {
        if (package_component_id) {
          toast.success( t("YourReservationHasBeenUpdated"),{
            position: "bottom-right",
          });
        } else {
          toast.success( t("YourReservationHasBeenAdded"),{
            position: "bottom-right",
          });
        }
        setLoading(false);
  
        onSuccess();
        if(!package_component_id){
          onRefresh();
        }

        else{
          let result = response?.data?.result;
          if(result){ 
            let result = response.data?.result;
            if(result){
              setItems(result.items??[]);
            }           
          }
        }

      } else {
        setErrorPopUp(true);
        let errorMessage= ""
        if(package_component_id){
          errorMessage = t("ErrorOccurredWhileUpdatingReservation");
        }
        else{
          errorMessage = t("ErrorOccurredWhileAddingReservation");

        }
        setErrorMessage(
          response.message ??
            errorMessage
        );
        setLoading(false);
      }
    } catch (error) {
      setErrorPopUp(true);

      let errorMessage = error?.message ? error?.message?.replace(/^Error:\s*/, ""): "";
      if(error){
        if(error.response?.data?.message){
          errorMessage = error.response?.data?.message
        }
      }

      let message= ""
        if(package_component_id){
          message = t("ErrorOccurredWhileUpdatingReservation");
        }
        else{
          message = t("ErrorOccurredWhileAddingReservation");
        }
      setErrorMessage(
        errorMessage ??
          message
      );
      setLoading(false);
      console.error("Error:", error);
    }
  };

  // useEffect(() => {
  //   fetchAirports();
  //   fetchAirlines();
  // }, []);

  const fetchReservationDetails = async () => {
    try {
      let apiUrl = `${url}/api/method/alltimes.www.api.flight_reservation_details?quotation_id=${package_name}&reservation_id=${package_component_id}`;

      setIsLoading(true);
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosGet(apiUrl, {}, headers);
      const result = response.result[0];
      if (result) {
        setReservationDetails(result);
        setFlightReservation({
          quotation_id: result.quotation_id,
          destination_airport: result.destination_airport,
          destination_airline: result.destination_airline,
          departure_date: result.departure_date,
          return_date: result.return_date,
          num_of_passengers: result.num_of_passengers??1,
          // tickets: result.tickets ? JSON.parse(JSON.parse(result.tickets)) : [],
          tickets: result.tickets ? JSON.parse(result.tickets) : [],
          contact_person_at_destination: result.contact_person_at_destination,
          already_reserved: result.already_reserved,
          quotation_item_date_from: result.departure_date?? null, // start Date For Quotation Component
          quotation_item_date_to: result.return_date?? null, // start Date For Quotation Component
          quotation_item_destination: selectedDestination.location,
          quotation_item_destination_row_id: selectedDestination.nprimary_destination_row_idame,
        });
        setAirlineInputValue(result.destination_airline);
        setAirportInputValue(result.destination_airport);
        // setAirlineInputValue(result.destination_airline_name);
        // setAirportInputValue(result.destination_airport_name);
        setIsLoading(false);
      }
      else {
        setAirlineInputValue(null);
        setAirportInputValue(null);
        setReservationDetails(null);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      return { data: null, error: error.message };
    }
  };

  useEffect(() => {
    if (package_component_id) {
      fetchReservationDetails();
    }
  }, [package_component_id]);


  if (isLoading) {
    return (
      <div className="loading-container">
        <SpinnerLoading />
      </div>
    );
  }
  return (
    <div className="component-form-container">
      <button className="component-form-backbtn" onClick={onReturn}>
      {Lang === "ar" ? (
          <>
            {t("BackToPlan")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 23 23"
              fill="none"
            >
              <path
                d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {t("BackToPlan")}
          </>
        )}
    </button>
      <div className="component-form-title">
        <div className="component-form-title-icon">
          <img src={flightIcon} alt="hotel"/>
        </div>
        <div>{t("AddFlightManually")}</div>
      </div>
      <div className="component-form-date">
        {formattedStart} - {formattedEnd} {t("In")} {" "} <span>{selectedDestination.location_name}</span>
      </div>
      <Accordion
        defaultActiveKey="0"
        className="component-form-accordion"
        alwaysOpen
      >
        <Accordion.Item eventKey="0" className="component-form-accordion-item">
          <Accordion.Header className="component-form-accordion-header">
            1. {t("FlightBookingDetails")}
          </Accordion.Header>
          <Accordion.Body className="component-form-accordion-body">
            <Row>
              <Col xl={3} lg={4} md={6}>
                <div className="component-form-input-container">
                  <label className="component-form-input-label">
                  {t("DestinationAirport")}    <span>*</span>
                  </label>
                  <Autocomplete
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    ref={destinationAirportRef}
                    style={{ width: "100%" }}
                    options={airports || []}
                    getOptionLabel={(option) => option.airport_name || ""} //option.airport_name
                    value={
                      flightReservation.destination_airport
                        ? { name: flightReservation.destination_airport,
                            airport_name: flightReservation.destination_airport_name
                         }
                        : null
                    }
                    inputValue={airportInputValue}
                    onChange={(event, newValue) => {
                      setFlightReservation((prev) => ({
                        ...prev,
                        destination_airport: newValue?.name || null,
                        destination_airport_name: newValue?.airport_name || null,
                      }));
                      setAirportInputValue(newValue?.airport_name || "");
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setAirportInputValue(newInputValue);
                        fetchAirports(newInputValue);
                      }
                    }}
                    onFocus={() => {
                      fetchAirports();
                    }}
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row", // Moves icon
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left: Lang === "ar" ? '9 !important' : "unset !important",
                        right:Lang === "ar" ? "unset !important" : '9 !important',
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left", // Align input text
                      },
                    }}
                    
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          size="small"
                          placeholder={t("DestinationAirport")}
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              direction: Lang === "ar" ? "rtl" : "ltr",
                            },
                            sx: {
                              backgroundColor: "#FFF",
                              borderRadius: "6px",
                              padding: "9px 15px !important",
                              fontFamily: '"Dmsans400"',
                              fontSize: "13px !important",
                              fontWeight: 400,
                              letterSpacing: "0.25px",
                            },
                          }}
                        />
                      );
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.name}>
                        {option.airport_name}
                      </li>
                    )}
                  />
                  {errors.destination_airport &&
                    !flightReservation.destination_airport && (
                      <div className="invalid-feedback">
                        {errors.destination_airport}
                      </div>
                    )}
                </div>
              </Col>
              <Col xl={3} lg={4} md={6}>
                <div className="component-form-input-container">
                  <label className="component-form-input-label">
                  {t("DestinationAirline")}  <span>*</span>
                  </label>
                  <Autocomplete
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    ref={destinationAirlineRef}
                    style={{ width: "100%" }}
                    options={airlines || []}
                    getOptionLabel={(option) => option.airline_name || ""}
                    value={
                      flightReservation.destination_airline
                        ? { airline_name: flightReservation.destination_airline }
                        : null
                    }
                    inputValue={airlineInputValue}
                    onChange={(event, newValue) => {
                      setFlightReservation((prev) => ({
                        ...prev,
                        destination_airline: newValue?.airline_name || null,
                        destination_airline_name: newValue?.airline_name || null, // Save it

                      }));
                      setAirlineInputValue(newValue?.airline_name || "");
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setAirlineInputValue(newInputValue);
                        fetchAirlines(newInputValue);
                      }
                    }}
                    onFocus={() => {
                      fetchAirlines();
                    }}
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row", // Moves icon

                      },
                      ".MuiAutocomplete-endAdornment": {
                        left: Lang === "ar" ? '9 !important' : "unset !important",
                        right:Lang === "ar" ? "unset !important" : '9 !important',
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left", // Align input text
                      },
                    }}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          size="small"
                          placeholder={t("DestinationAirline")}
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              direction: Lang === "ar" ? "rtl" : "ltr",
                            },
                            sx: {
                              backgroundColor: "#FFF",
                              borderRadius: "6px",
                              padding: "9px 15px !important",
                              fontFamily: '"Dmsans400"',
                              fontSize: "13px !important",
                              fontWeight: 400,
                              letterSpacing: "0.25px",
                            },
                          }}
                        />
                      );
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.airline_name}>
                        {option.airline_name}
                      </li>
                    )}
                  />
                  {errors.destination_airline &&
                    !flightReservation.destination_airline && (
                      <div className="invalid-feedback">
                        {errors.destination_airline}
                      </div>
                    )}
                  {/* <input type='text' className='component-form-input' /> */}
                </div>
              </Col>
              <Col xl={3} lg={4} md={6}>
                <div className="component-form-input-container">
                  <label className="component-form-input-label">
                  {t("DepartureDate")}  <span>*</span>
                  </label>
                  <SingleCalendar
                    dateRef={departureDateRef}
                    placeholder={t("DepartureDate")}
                    value={
                      flightReservation.departure_date
                        ? new Date(flightReservation.departure_date)
                        : null
                    }
                    onChange={(e) =>
                  
                      setFlightReservation((prev) => ({
                      ...prev,
                      departure_date:  e.value != null ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss") : null,
                      quotation_item_date_from: e?.value != null ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss") : null,
                    }))
                    }
                    min={new Date (selectedDates.startDate)}
                    max={
                      flightReservation.return_date
                        ? new Date(
                            Math.min(
                              new Date(flightReservation.return_date).getTime(),
                              new Date(selectedDates.endDate).getTime()
                            )
                          )
                        : new Date(selectedDates.endDate)
                    }
                    viewDate={new Date(selectedDates.startDate)}
                />
                  {errors.departure_date &&
                    !flightReservation.departure_date && (
                      <div className="invalid-feedback">
                        {errors.departure_date}
                      </div>
                    )}
                </div>
              </Col>
              <Col xl={3} lg={4} md={6}>
                <div className="component-form-input-container">
                  <label className="component-form-input-label">
                  {t("ReturnDate")}
                  </label>
                  <SingleCalendar
                    placeholder={t("ReturnDate")}
                    value={
                      flightReservation.return_date
                        ? new Date(flightReservation.return_date)
                        : null
                    }
                    onChange={(e) =>
                      setFlightReservation((prev) => ({
                        ...prev,
                        return_date:  e.value != null ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss") : null,
                        quotation_item_date_to: e?.value != null ? dayjs(e.value).format("YYYY-MM-DD HH:mm:ss") : null,
                      }))
                    }
                    min={
                      flightReservation.departure_date
                        ? new Date(
                            Math.max(
                              new Date(flightReservation.departure_date).getTime(),
                              new Date(selectedDates.startDate).getTime()
                            )
                          )
                        : new Date(selectedDates.startDate)
                    }             
                    max={new Date(selectedDates.endDate)}
                    viewDate={new Date(selectedDates.endDate)}
                  />
                </div>
              </Col>
              <Col xl={3} lg={4} md={6}>
                <div className="component-form-input-container">
                  <label className="component-form-input-label">
                  {t("NumberOfPassengers")}  <span>*</span>
                  </label>
                  <input 
                    ref={numOfPassengersRef}
                    type="number"
                    min={1}
                    className="component-form-input"
                    value={flightReservation.num_of_passengers}
                    onChange={(val) => {
                      setFlightReservation((prev) => {
                        const num = val.target.value;
                        const newTickets = Array.from(
                          { length: num },
                          (_, i) => prev.tickets?.[i] || ""
                        );
                        return {
                          ...prev,
                          num_of_passengers: num,
                          tickets: newTickets,
                        };
                      });
                    }}
                  />
                  {errors.num_of_passengers &&
                    (!flightReservation.num_of_passengers ||
                    flightReservation.num_of_passengers == 0) && (
                      <div className="invalid-feedback">
                        {errors.num_of_passengers}
                      </div>
                    )}
                </div>
              </Col>
              {Array.isArray(flightReservation.tickets) &&
                flightReservation.tickets.length > 0 &&
                flightReservation.tickets.map((item, index) => {
                  return (
                    <Col xl={3} lg={4} md={6}>
                      <div className="component-form-input-container">
                        <label className="component-form-input-label">
                          {" "}
                          {t("TicketOfPassenger")} ({index + 1}) <span>*</span>
                        </label>
                        <input
                          ref={ticketsRef}
                          type="text"
                          className="component-form-input"
                          placeholder={t("AddTicket")}
                          // value={item}
                          value={item?item.toString() : ""}

                          onChange={(e) => {
                            const value_ticket = e.target.value;
                            setFlightReservation((prev) => {
                              const updatedTickets = [...prev.tickets];
                              updatedTickets[index] = value_ticket;
                              return {
                                ...prev,
                                tickets: updatedTickets,
                              };
                            });
                          }}
                        />
                      </div>
                      {errors.tickets && !item && (
                        <div className="invalid-feedback">{errors.tickets}</div>
                      )}
                    </Col>
                  );
                })}
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" className="component-form-accordion-item">
          <Accordion.Header className="component-form-accordion-header">
            2. {t("TravelAndContactDetails")}
          </Accordion.Header>
          <Accordion.Body className="component-form-accordion-body">
            <Row>
              <Col xl={3} lg={4} md={6}>
                <div className="component-form-input-container">
                  <label className="component-form-input-label">
                  {t("ContactPersonAtDestination")}
                  </label>
                  <input
                    type="tel"
                    ref={contactDestRef}
                    inputMode="tel"
                    // pattern="[0-9+ ]*"
                    // maxLength={15}
                    className="component-form-input"
                    placeholder={t("AddContactPerson")}
                    value={flightReservation.contact_person_at_destination}
                    onChange={(val) =>

                      {
                        // if (/^[0-9+ ]*$/.test(val.target.value)) {
                          setFlightReservation((prev) => ({
                            ...prev,
                            contact_person_at_destination: val.target.value,
                          }));
                        // }
                      }
                    }
                    
                  />
                    {errors.contact_person && !phoneRegex.test(flightReservation.contact_person_at_destination) && flightReservation.contact_person_at_destination && (
                        <div className="invalid-feedback">{errors.contact_person}</div>
                      )}
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <button
        className={`component-form-addbtn ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        onClick={(e) => {
          if (!loading) {
            handleClickButton(e);
          }
        }}
        disabled={loading}
      >
        {loading
          ? t("Loading") + "..."
          : package_component_id
          ? t("UpdateFlightReservation")
          : t("AddFlightReservation")}
      </button>

      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
      <ErrorPopUp message={errorMessage} showpopUp={errorPopUp} handleClose={()=>{setErrorPopUp(false); setErrorMessage(null)}}/> 

    </div>
  );
};

export default FlightForm;
